/* eslint-disable no-unused-vars */
import React, { useState, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Modal from '@bitcoin-portal/bitcoincom-pkg-components/dist/Modal';
import QRCode from '@bitcoin-portal/bitcoincom-pkg-components/dist/QRCode';
import { handleRipple } from '../../../helpers/ripple';
import {
  StyledSection,
  StyledContentBlock,
  Icon,
  Title,
  Subtitle,
  Imagewrapper,
  Image,
  StyledButton,
  Contentwrapper,
  Textwrapper,
  Titlewrapper,
  MobileButton,
  StyledGatsbyLink,
} from './styled';
import {
  QrCodeWrapper,
  StyledTitle,
  StyledSubtitle,
  ModalWrapper,
} from '../../../components/QrCodeModalV2/styled';

const Rewards = ({ locale, mobileButtonLink }) => {
  const modalRef = useRef();
  const { messages } = useIntl();
  const [selectedStore, setSelectedStore] = useState('GOOGLE_PLAY');

  const qrValue =
    selectedStore === 'GOOGLE_PLAY'
      ? messages['global.qrcodeModal.google-play.link']
      : messages['global.qrcodeModal.app-store.link'];

  const handleMobileButtonClick = e => {
    e.preventDefault();

    window.location.href = '/download';
  };

  return (
    <>
      <StyledSection>
        <StyledContentBlock>
          <Contentwrapper>
            <Icon
              src={messages['home.rewards.icon.src']}
              alt={messages['home.rewards.icon.alt']}
            />

            <Textwrapper>
              <Titlewrapper>
                <Title locale={locale}>
                  <FormattedMessage id="home.rewards.title" />
                </Title>
                <Subtitle>
                  <FormattedMessage id="home.rewards.subtitle" />
                </Subtitle>
                <StyledButton
                  onMouseEnter={handleRipple}
                  onClick={() => modalRef.current.open()}
                  className="ga-wallet-cta get-app-cta-button-2"
                >
                  <FormattedMessage id="home.rewards.button" />
                </StyledButton>
                <MobileButton
                  onMouseEnter={handleRipple}
                  onClick={handleMobileButtonClick}
                >
                  <FormattedMessage id="home.rewards.button" />
                </MobileButton>
              </Titlewrapper>
            </Textwrapper>
          </Contentwrapper>
          <Imagewrapper>
            <Image
              src={messages['home.rewards.image.src']}
              alt={messages['home.rewards.image.alt']}
            />
          </Imagewrapper>
        </StyledContentBlock>
      </StyledSection>
      <ModalWrapper>
        <Modal ref={modalRef}>
          <StyledTitle>{messages['global.qrcodeModal.title']}</StyledTitle>
          <StyledSubtitle>
            {messages['global.qrcodeModal.description']}
          </StyledSubtitle>
          {/* <StoreToggle
            selectedStore={selectedStore}
            setSelectedStore={setSelectedStore}
          /> */}
          <QrCodeWrapper>
            <div style={{ width: '100%' }}>
              <img
                src="/images/uploads/download.png"
                alt="QR Code to download Bitcoin.com Wallet"
                style={{
                  width: '236px',
                  height: '236px',
                }}
              />
            </div>
          </QrCodeWrapper>
          <StyledGatsbyLink
            to="https://support.bitcoin.com/en/articles/12380851-how-to-scan-a-qr-code"
            target="_blank"
          >
            {messages['global.qrcodeModal.support']}
          </StyledGatsbyLink>
        </Modal>
      </ModalWrapper>
    </>
  );
};

Rewards.propTypes = {
  locale: PropTypes.string.isRequired,
  mobileButtonLink: PropTypes.string.isRequired,
};

export default Rewards;
